import { FC, PropsWithChildren } from 'react'
import createCache, { EmotionCache } from '@emotion/cache'
import { CacheProvider as EmotionCacheProvider } from '@emotion/react'

let muiCache: EmotionCache | undefined

// eslint-disable-next-line no-return-assign
const createMuiCache = (nonce?: string, container?: ShadowRoot) =>
  (muiCache =
    muiCache ??
    createCache({
      key: 'mui',
      nonce,
      prepend: true,
      container,
    }))

type Props = {
  nonce?: string
  container?: ShadowRoot
}

export const CacheProvider: FC<PropsWithChildren<Props>> = ({ children, nonce, container }) => (
  <EmotionCacheProvider value={createMuiCache(nonce, container)}>{children}</EmotionCacheProvider>
)
